const CLIENT_DEFAULT_TYPE = 'CLIENT_TYPE_B2C'

const EMPLOYEE_DEFAULT_TYPE = 'CLIENT_TYPE_EMPLOYEE'

export {
  CLIENT_DEFAULT_TYPE,
  EMPLOYEE_DEFAULT_TYPE
}
